import { render } from "./MagicLogin.vue?vue&type=template&id=4fa91a9c&scoped=true"
import script from "./MagicLogin.vue?vue&type=script&lang=ts"
export * from "./MagicLogin.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4fa91a9c"

export default script